export const translations = {
    en: {
        // Navbar
        navHome: "Home",
        navAboutUs: "About Us",
        navNewRequest: "New Request",
        navCheckStatus: "Check Status",
        navContactUs: "Contact Us",
        navAdminDashboard: "Dashboard",
        navAdminLogin: "Admin",
        navLogout: "Logout",
        languageSwitch: "العربية",
        previousPage: "Previous",
        nextPage: "Next",

        // Welcome Page
        welcomeTitle: "Say Tech",
        welcomeSubtitle: "Your Trusted Data Recovery Experts",
        welcomeDescription: "Located in Saihat, Saudi Arabia, we specialize in recovering precious data from iPhones. Our lead technician brings 14 years of experience in aviation mechanics and electricity, ensuring meticulous care and expertise for your device.",
        welcomeCommitment: "We understand the value of your data and are committed to delivering it back to you safely.",
        getQuoteButton: "Get Your Data Back",
        ourLocation: "Our Location: Saihat, Saudi Arabia",
        ourExpertiseTitle: "Our Expertise in Action",
        expertAtWorkAlt: "Technician carefully working on data recovery from a smartphone.",
        testimonialsTitle: "What Our Customers Say",
        loadingTestimonials: "Loading testimonials...",
        testimonial1Name: "Ahmed Al-Mansoori", 
        testimonial1Quote: "Say Tech recovered all my precious family photos from my broken iPhone! I thought they were lost forever. Amazing service and very professional.",
        testimonial1Device: "iPhone 13 Pro",
        testimonial2Name: "Fatima Al-Zahrani",
        testimonial2Quote: "My business data was on my water-damaged phone. Say Tech saved the day! Quick turnaround and excellent communication throughout the process.",
        testimonial2Device: "iPhone 12",
        testimonial3Name: "John D.",
        testimonial3Quote: "Incredible skill! They managed to retrieve data from a phone other shops said was unrecoverable. Highly recommended!",
        testimonial3Device: "iPhone X",
        beforeAfterTitle: "From Broken to Recovered",
        loadingBeforeAfter: "Loading recovery examples...",
        beforeTitle: "Before: Data Seemed Lost",
        beforeDescription1: "A severely damaged iPhone, unresponsive and seemingly beyond repair. Precious memories and important files trapped inside.",
        beforeImageAlt1: "Severely damaged smartphone with cracked screen.",
        afterTitle: "After: Data Successfully Retrieved!",
        afterDescription1: "Thanks to Say Tech's expertise, all critical data was recovered, bringing relief and joy to the owner.",
        afterImageAlt1: "Smartphone displaying a success message or recovered files.",
        beforeDescription2: "Water-damaged device, refusing to power on. Critical business contacts and project files were at stake.",
        beforeImageAlt2: "Smartphone with signs of water damage.",
        afterDescription2: "Say Tech's meticulous work brought the data back, ensuring business continuity.",
        afterImageAlt2: "Smartphone showing a list of recovered contacts or files.",
        pricingOfferTitle: "Transparent Pricing",
        pricingOfferText: "Recover your precious data for 2000 Saudi Riyals, plus shipping costs (both ways).",
        pricingOfferDetails: "This flat rate covers most common iPhone data recovery scenarios. Complex cases may require a custom quote after initial evaluation. Contact us for more details.",
        ourProcessTitle: "Our Simple Recovery Process",
        processStep1Title: "1. Submit & Pay",
        processStep1Desc: "Fill out our secure online form with your device details and complete the initial payment.",
        processStep2Title: "2. Easy Shipping",
        processStep2Desc: "Our shipping partner will contact you to arrange a convenient pickup of your device.",
        processStep3Title: "3. Expert Recovery",
        processStep3Desc: "Our experienced technicians will meticulously work to recover your valuable data.",
        processStep4Title: "4. Data Returned",
        processStep4Desc: "Once recovered, we'll securely return your data and device to you.",

        // Contact Us Page
        contactUsTitle: "Contact Us",
        contactUsSubtitle: "Have questions? We'd love to hear from you.",
        contactFormTitle: "Send Us a Message",
        nameLabel: "Name",
        messageLabel: "Message",
        sendMessageButton: "Send Message",
        sendingMessage: "Sending...",
        messageSentSuccess: "Your message has been sent successfully!",
        messageSentError: "Failed to send message. Please try again.",
        contactInfoTitle: "Contact Information",
        contactAddress: "7575 King Abdulaziz Rd, Ghirnatah, Saihat 32434, Saudi Arabia",
        contactPhone: "+966547399661",
        contactWhatsApp: "Contact us on WhatsApp",
        contactPOBox: "P.O. Box: [Your P.O. Box Here]",

        // About Us Page
        aboutTitle: "About Say Tech",
        aboutSubtitle: "Your partners in digital resurrection. We bring lost data back to life.",
        aboutOurStoryTitle: "Our Story",
        aboutOurStoryP1: "Founded from a passion for technology and a deep-seated desire to solve complex problems, Say Tech started with a simple mission: to recover what was thought to be lost. Our lead technician, with 14 years of experience in the high-stakes field of aviation electronics, brings a level of precision and discipline to data recovery that is second to none.",
        aboutOurStoryP2: "We believe that every byte of data tells a story, holds a memory, or runs a business. Losing it can be devastating. That's why we've dedicated ourselves to mastering the intricate art of data recovery, combining cutting-edge technology with meticulous, hands-on expertise to reunite you with your digital life.",
        aboutFeature1Title: "Precision Engineering",
        aboutFeature1Desc: "Leveraging a background in aviation mechanics, we apply meticulous, systematic processes to every recovery task.",
        aboutFeature2Title: "Customer-Centric",
        aboutFeature2Desc: "We prioritize clear communication and transparency, keeping you informed every step of the way.",
        aboutFeature3Title: "Cutting-Edge Technology",
        aboutFeature3Desc: "We invest in the latest tools and techniques to tackle even the most challenging data recovery scenarios.",
        aboutJoinUsTitle: "Join Our Story of Success",
        aboutJoinUsDesc: "Trust us with your device, and let us make you our next success story. We're not just recovering data; we're restoring peace of mind.",

        // Shipping Policy
        shippingPolicyTitle: "Delivery and Shipping Policy",
        shippingPolicyContact: "Our shipping partner will contact you within 48 business hours to arrange the pickup of your device.",
        shippingPolicyCosts: "Shipping costs, for both sending the device to us and returning it, are the customer's responsibility.",
        shippingPolicyReturn: "After successful data recovery, we will ship your recovered data within 48 business hours.",
        shippingPolicyOwnership: "As part of the service agreement, ownership of the original device is transferred to Say Tech upon completion of the process.",

        // Refund Policy
        refundPolicyTitle: "Refund Policy",
        refundPolicyGeneral: "Refunds will be credited to the original mode of payment and processed within 10 to 45 days, depending on the issuing bank of the credit card.",
        refundPolicyCancellation: "A full refund is available if the cancellation is requested before the device has been shipped to our store, or within 10 days of payment if the device has not yet been shipped.",
        refundPolicyPartial: "In cases where data recovery is not possible, a partial refund of 1200 SAR will be issued. A fee of 300 SAR is retained for the technical evaluation and processing.",
        refundPolicyDamaged: "A full refund will be issued if the device is damaged during shipping.",

        // Privacy Policy
        privacyPolicyTitle: "Privacy Policy",
        privacyPolicyIntro: "Your privacy is critically important to us. This policy outlines how we handle and protect your personal information and data.",
        privacyPolicyDataHandling: "Data Handling: Once your data is recovered, it is immediately transferred to a secure, encrypted hard drive. This hard drive is then prepared for shipment back to you.",
        privacyPolicyConfidentiality: "Confidentiality: Our recovery process is designed to be non-intrusive. Our technicians do not view the contents of your files. We maintain strict confidentiality and only access the data structure necessary to perform the recovery.",
        privacyPolicySecurity: "Security: We implement a variety of security measures to maintain the safety of your personal information and recovered data throughout the entire process.",
        privacyPolicyNoStore: "All credit/debit cards’ details and personally identifiable information will NOT be stored, sold, shared, rented or leased to any third parties.",
        privacyPolicyPaymentProvider: "If you make a payment for our products or services on our website, the details you are asked to submit will be provided directly to our payment provider via a secured connection.",
        privacyPolicyThirdPartyLinks: "We are not responsible for the privacy policies of websites to which we link. If you provide any information to such third parties, different rules regarding the collection and use of your personal information may apply.",
        privacyPolicyAds: "Currently, we do not use third-party ad networks. However, in the future, some advertisements may be delivered by third parties who may collect information about your online activities. The information practices of these third parties are not covered by this privacy policy.",

        // Terms and Conditions
        tncTitle: "Terms and Conditions",
        tncIntro: "Welcome to Say Tech. These terms and conditions outline the rules and regulations for the use of our website and services.",
        tncGoverningLawTitle: "Governing Law & Jurisdiction",
        tncGoverningLawText1: "Any dispute or claim arising out of or in connection with this website shall be governed and construed in accordance with the laws of {country}.",
        tncGoverningLawText2: "{country} is our country of domicile.",
        tncUserAgeTitle: "User Age",
        tncUserAgeText: "Customers using the website who are Minors/under the age of 18 shall not register as a User of the website and shall not transact on or use the website.",
        tncPaymentTitle: "Payment",
        tncPaymentText: "We accept payments online using Visa and MasterCard credit/debit card in {currencies}.",
        tncCardholderResponsibility: "The cardholder must retain a copy of transaction records and Merchant policies and rules.",
        tncAccountConfidentiality: "User is responsible for maintaining the confidentiality of his account.",
        tncPolicyUpdatesTitle: "Policy Updates",
        tncPolicyUpdatesText: "The Website Policies and Terms & Conditions may be changed or updated occasionally to meet the requirements and standards. Therefore the Customers’ are encouraged to frequently visit these sections in order to be updated about the changes on the website. Modifications will be effective on the day they are posted.",
        tncOfacTitle: "OFAC Sanctioned Countries",
        tncOfacText: "{websiteUrl} will NOT deal or provide any services or products to any of OFAC (Office of Foreign Assets Control) sanctions countries in accordance with the law of {country}.",
        tncMultipleTransactions: "Multiple transactions may result in multiple postings to the cardholder’s monthly statement.",
        countryName: "Saudi Arabia",


        // Request Form Page
        requestServiceTitle: "Request Data Recovery Service",
        requestServiceSubtitle: "Fill out the form below. We'll contact you via WhatsApp to arrange device shipment.",
        yourInformationTitle: "Your Information",
        yourInformationDescription: "Please provide your contact and device details.",
        fullNameLabel: "Full Name",
        fullNamePlaceholder: "Your Full Name",
        countryCodeLabel: "Country Code",
        countryCodePlaceholder: "Select Code",
        localPhoneNumberLabel: "Phone Number (WhatsApp)",
        localPhoneNumberPlaceholder: "5XXXXXXXX",
        emailLabel: "Email",
        emailPlaceholder: "youremail@example.com",
        cityLabel: "City",
        cityPlaceholder: "e.g., Dammam",
        regionLabel: "Region/Province",
        regionPlaceholder: "e.g., Eastern Province",
        phoneModelLabel: "Phone Model",
        phoneModelSelectPlaceholder: "Select Phone Model",
        previouslyRepairedLabel: "Has device been repaired before?",
        previouslyRepairedPlaceholder: "Select an option",
        yesOption: "Yes",
        noOption: "No",
        deviceConditionLabel: "Current Device Condition",
        deviceConditionPlaceholder: "Select condition",
        conditionFellInWater: "Fell in water",
        conditionPhysicalDamage: "Physical damage (hit/dropped)",
        conditionNoPower: "Won't turn on / No power",
        conditionScreenIssue: "Screen issue (no physical damage)",
        conditionBatteryIssue: "Battery issue",
        conditionSoftwareIssue: "Software issue / Stuck on logo",
        conditionOther: "Other",
        issueDescriptionLabel: "Issue Description",
        issueDescriptionPlaceholder: "Describe the issue with your iPhone in detail",
        deviceImageLabel: "Upload Picture of Device",
        deviceImagePlaceholder: "Choose file...",
        fileNameLabel: "Selected file:",
        paymentMethodLabel: "Preferred Payment Method",
        paymentMethodPlaceholder: "Select a payment method",
        paymentCreditCard: "Credit Card (via Moyasar)",
        paymentApplePay: "Apple Pay (via Moyasar - Simulated)",
        paymentBankTransfer: "Bank Transfer (STC Pay / MADA - Simulated)", 
        paymentMada: "Mada (via Moyasar - Simulated)",
        paymentSTCPay: "STC Pay (via Moyasar - Simulated)",
        agreementCheckboxLabel: "I have read and agree to the terms and conditions.",
        viewAgreementLink: "View Agreement",
        errorAgreementRequiredTitle: "Agreement Required",
        errorAgreementRequiredText: "You must agree to the terms and conditions to proceed.",
        agreementModalTitle: "Terms and Conditions",
        agreementTextLine1: "Welcome to Say Tech! These terms and conditions outline the rules and regulations for the use of Say Tech's Data Recovery Services.",
        agreementTextLine2: "By accessing this website and/or submitting a service request, we assume you accept these terms and conditions. Do not continue to use Say Tech's services if you do not agree to all of the terms and conditions stated on this page.",
        agreementServiceTitle: "Service Provision",
        agreementServiceText1: "Say Tech agrees to perform data recovery services on the device(s) submitted by you. We will use our best efforts to recover your data. However, data recovery is not guaranteed and depends on the condition of the device and data.",
        agreementServiceText2: "An initial non-refundable evaluation fee (if applicable and communicated) and the agreed service fee must be paid. Shipping costs for sending the device to us and returning it to you are your responsibility.",
        agreementPaymentTitle: "Payment",
        agreementPaymentText1: "The full service fee is due upon successful data recovery, prior to the return of your data and device. If data recovery is unsuccessful, only the evaluation fee (if any) and return shipping costs will be charged.",
        agreementUserResponsibilityTitle: "Your Responsibilities",
        agreementUserResponsibilityText1: "You confirm that you are the legal owner of the device and the data contained therein, or have obtained explicit consent from the legal owner to submit the device for data recovery.",
        agreementUserResponsibilityText2: "You are responsible for accurately describing the device's condition and the issue. Misrepresentation may affect the recovery process and costs.",
        agreementLimitationTitle: "Limitation of Liability",
        agreementLimitationText1: "Say Tech is not liable for any damage to the device that may occur during the evaluation or recovery process, especially if the device was previously tampered with or severely damaged. We are not liable for any loss of profits, data, or any indirect, special, incidental, or consequential damages.",
        agreementConfidentialityTitle: "Confidentiality",
        agreementConfidentialityText1: "We will treat your data with the utmost confidentiality and will not disclose it to third parties, except as required by law.",
        agreementShippingTitle: "Shipping & Device Return",
        agreementShippingText1: "You are responsible for all shipping costs. Devices not claimed or for which return shipping is not paid within 60 days of notification may be disposed of.",
        agreementChangesTitle: "Changes to Terms",
        agreementChangesText1: "Say Tech reserves the right to revise these terms at any time. By using this service, you are expected to review these terms on a regular basis.",
        agreementContactTitle: "Contact Us",
        agreementContactText1: "If you have any questions about these Terms, please contact us.",
        iAgreeButton: "I Agree",
        proceedToPaymentButton: "Proceed to Payment",
        submittingButton: "Submitting...",
        errorMissingInfoTitle: "Missing Information",
        errorMissingInfoText: "Please fill in all required fields.",
        errorInvalidEmailTitle: "Invalid Email",
        errorInvalidEmailText: "Please enter a valid email address.",
        errorInvalidPhoneTitle: "Invalid Phone Number",
        errorInvalidPhoneText: "Please enter a valid country code and local phone number.",
        submissionFailedTitle: "Submission Failed",
        submissionFailedText: "An unexpected error occurred. Please try again.",
        requestSubmittedTitle: "Request Submitted!",
        requestSubmittedText: "Your service request and payment have been successfully processed.",
        importantSaveInfoTitle: "Important: Save This Information!",
        importantSaveInfoText: "Please save your Request ID and Verification Code. You'll need them to check your request status.",
        requestIdLabel: "Request ID:",
        verificationCodeLabel: "Verification Code:",
        transactionIdLabel: "Transaction ID:",
        contactWhatsAppText: "We will contact you via WhatsApp at {phoneNumber} to arrange the shipment of your device.",
        checkStatusNowButton: "Check Status Now",
        paymentModalTitle: "Simulated Secure Payment",
        paymentAmountLabel: "Amount to Pay:",
        SAR: "SAR",
        cardNumberLabel: "Card Number",
        cardNumberPlaceholder: "•••• •••• •••• ••••",
        expiryDateLabel: "Expiry Date",
        expiryDatePlaceholder: "MM/YY",
        cvvLabel: "CVV",
        cvvPlaceholder: "•••",
        payNowButton: "Pay Now (Simulated)",
        proceedToSecurePaymentButton: "Proceed to Secure Payment (Simulated)",
        moyasarRedirectMessage: "You will be redirected to a secure Moyasar page to complete your payment with {paymentMethod}.",
        processingPaymentButton: "Processing Payment...",
        paymentSuccessfulTitle: "Payment Successful",
        paymentSuccessfulText: "Your payment was processed successfully.",
        paymentFailedTitle: "Payment Failed",
        paymentFailedText: "Could not process payment. Please check your details or try another card.",
        paymentFailedCardDeclined: "Your card was declined. Please try a different card or contact your bank.",
        closeButton: "Close",
        paymentCancelledTitle: "Payment Cancelled",
        paymentCancelledText: "Payment was cancelled. Please try again.",
        paymentTimeoutTitle: "Payment Timeout",
        paymentTimeoutText: "Payment process took too long. Please try again.",
        paymentInProgressMessage: "Payment in progress. Please complete the payment in the popup window...",
        tryAgainButton: "Try Again",
        popupBlockedTitle: "Popup Blocked",
        popupBlockedText: "Please allow popups for this site to complete the payment process.",

        
        // Status Check Page
        checkRequestStatusTitle: "Check Request Status",
        checkRequestStatusSubtitle: "Enter your order ID to view the current status of your recovery.",
        orderIdLabel: "Order ID",
        orderIdPlaceholder: "Enter your transaction/order ID",
        errorOrderIdRequired: "Please enter your order ID",
        useRequestIdButton: "Use Request ID",
        usePhoneNumberButton: "Use Phone Number",
        requestIdInputLabel: "Request ID",
        requestIdInputPlaceholder: "REQ-XXXXXX",
        phoneNumberInputLabel: "Phone Number",
        phoneNumberInputPlaceholder: "+966XXXXXXXXX",
        sendVerificationCodeButton: "Send Verification Code",
        sendingCodeButton: "Sending Code...",
        verificationCodeSentTitle: "Verification Code Sent",
        verificationCodeSentTextRequestId: "A (mock) verification code has been sent for Request ID: {requestId}. Please check your registered channel.",
        verificationCodeSentTextPhone: "A (mock) verification code has been sent to {phoneNumber}. Please check your SMS.",
        verificationCodeInputLabel: "Verification Code",
        verificationCodeInputPlaceholder: "Enter 6-digit code",
        checkStatusButton: "Check Status",
        checkingStatusButton: "Checking Status...",
        changeRequestIdLink: "Change Request ID?",
        changePhoneNumberLink: "Change Phone Number?",
        orResendCodeLink: "or Resend Code",
        errorInputRequiredTitle: "Input Required",
        errorEnterRequestId: "Please enter your Request ID.",
        errorEnterPhoneNumber: "Please enter a valid Phone Number (e.g., +966XXXXXXXXX).",
        errorFailedToSendCodeTitle: "Failed to Send Code",
        errorFailedToSendCodeText: "An error occurred while sending the verification code.",
        errorEnterVerificationCode: "Please enter the verification code.",
        statusCheckFailedTitle: "Status Check Failed",
        statusCheckFailedTextDefault: "Could not retrieve status.",
        errorNotFoundTitle: "Not Found",
        errorRequestIdNotFound: "Request ID not found.",
        errorPhoneNumberNotFound: "Phone number not found or verification failed.",
        errorGenericTitle: "Error",
        statusForRequestId: "Status for Request ID: {requestId}",
        requestStatusTitle: "Request Status",
        multipleRequestsStatusTitle: "Status for Your Requests",
        statusPaid: "Paid. Waiting for device shipment.",
        statusShipped: "Device shipped to our store.",
        statusDelivered: "Device delivered to our store. Under inspection.",
        statusEvaluatingDevice: "Device under evaluation.",
        statusDataRecovered: "Data recovery successful! Ready for return.",
        statusDataCantRecover: "Unfortunately, data recovery was unsuccessful.",
        statusPending: "Pending Payment. Please complete payment to proceed.",
        statusErrorInRequest: "Error in request.",
        statusUnknown: "Unknown Status",

        // Admin Login Page
        adminLoginTitle: "Admin Login",
        usernameLabel: "Username",
        usernamePlaceholder: "admin",
        passwordLabel: "Password",
        passwordPlaceholder: "admin123",
        loginButton: "Login",
        loggingInButton: "Logging In...",
        loginFailedText: "Login failed.",
        
        // Admin Dashboard Page
        adminDashboardTitle: "Admin Dashboard",
        refreshRequestsButton: "Refresh Requests",
        loadingAdminDashboard: "Loading Admin Dashboard...",
        errorLoadingDashboardTitle: "Error Loading Dashboard",
        failedToFetchRequests: "Failed to fetch requests.",
        tableHeaderRequestId: "Request ID",
        tableHeaderCustomer: "Customer",
        tableHeaderPhoneModel: "Phone Model",
        tableHeaderStatus: "Status",
        tableHeaderActions: "Actions",
        viewEditButton: "View/Edit",
        requestDetailsTitle: "Request Details: {requestId}",
        customerLabel: "Customer:",
        emailLabelModal: "Email:",
        phoneModelLabelModal: "Phone Model:",
        issueLabelModal: "Issue:",
        paymentInfoLabelModal: "Payment Info:",
        currentStatusLabelModal: "Current Status:",
        updateStatusLabelModal: "Update Status:",
        selectNewStatusPlaceholder: "Select new status",
        saveStatusChangeButton: "Save Status Change",
        updatingButtonModal: "Updating...",
        statusUpdateSuccessText: "Status for {requestId} updated to {newStatus}",
        statusUpdateFailedText: "Failed to update status.",
        statusUpdateErrorText: "Error updating status.",
        statusOptionPending: "Pending",
        statusOptionPaid: "Paid",
        statusOptionShipped: "Shipped",
        statusOptionDelivered: "Delivered",
        statusOptionEvaluatingDevice: "Evaluating Device",
        statusOptionDataRecovered: "Data Recovered",
        statusOptionDataCantRecover: "Data Can't Recover",
        page: "Page",
        of: "of",
        loadingRequests: "Loading requests...",
        noRequestsFound: "No requests found.",
        searchPlaceholder: "Search by ID, Name, Email, Phone, Status...",
        searchButton: "Search",
        clearSearchButton: "Clear",
        filterAll: "All",
        filterInProgress: "In Progress",
        filterDone: "Done",
        filterByStatus: "Filter by Status:",


        // Footer
        footerRightsReserved: "© {year} Say Tech. All rights reserved.",
        footerServiceLocation: "Data Recovery Services, Saihat, Saudi Arabia.",
        footerContactUs: "Contact Us",
        footerEmail: "Email:",
        footerPhone: "Phone:",
        footerFollowUs: "Follow Us",


        // General
        loadingMessage: "Loading...",
        requiredFieldIndicator: "*",
    },
    ar: {
        // Navbar
        navHome: "الرئيسية",
        navAboutUs: "من نحن",
        navNewRequest: "طلب جديد",
        navCheckStatus: "تحقق من الحالة",
        navContactUs: "اتصل بنا",
        navAdminDashboard: "لوحة التحكم",
        navAdminLogin: "دخول المسؤول",
        navLogout: "تسجيل الخروج",
        languageSwitch: "English",
        previousPage: "السابق",
        nextPage: "التالي",

        // Welcome Page
        welcomeTitle: "ساي تك",
        welcomeSubtitle: "خبراء استعادة البيانات الموثوق بهم",
        welcomeDescription: "موقعنا في سيهات، المملكة العربية السعودية، متخصصون في استعادة البيانات الثمينة من أجهزة آيفون. يتمتع فنينا بخبرة 14 عامًا في ميكانيكا وكهرباء الطيران، مما يضمن رعاية فائقة وخبرة لجهازك.",
        welcomeCommitment: "نحن نتفهم قيمة بياناتك ونلتزم بإعادتها إليك بأمان.",
        getQuoteButton: "استرجع بياناتك",
        ourLocation: "موقعنا: سيهات، المملكة العربية السعودية",
        ourExpertiseTitle: "خبرتنا في العمل",
        expertAtWorkAlt: "فني يعمل بعناية على استعادة البيانات من هاتف ذكي.",
        testimonialsTitle: "ماذا يقول عملاؤنا",
        loadingTestimonials: "جاري تحميل آراء العملاء...",
        testimonial1Name: "أحمد المنصوري",
        testimonial1Quote: "ساي تك استعادوا جميع صور عائلتي الثمينة من جهاز آيفون المكسور! ظننت أنها ضاعت إلى الأبد. خدمة مذهلة واحترافية عالية.",
        testimonial1Device: "آيفون 13 برو",
        testimonial2Name: "فاطمة الزهراني",
        testimonial2Quote: "بيانات عملي كانت على هاتفي المتضرر من الماء. ساي تك أنقذوا الموقف! سرعة في الإنجاز وتواصل ممتاز طوال العملية.",
        testimonial2Device: "آيفون 12",
        testimonial3Name: "جون د.",
        testimonial3Quote: "مهارة لا تصدق! تمكنوا من استرداد البيانات من هاتف قالت عنه متاجر أخرى أنه غير قابل للاسترداد. موصى به بشدة!",
        testimonial3Device: "آيفون X",
        beforeAfterTitle: "من مكسور إلى مُستعاد",
        loadingBeforeAfter: "جاري تحميل أمثلة الاسترداد...",
        beforeTitle: "قبل: بيانات بدت مفقودة",
        beforeDescription1: "آيفون متضرر بشدة، لا يستجيب ويبدو أنه لا يمكن إصلاحه. ذكريات ثمينة وملفات هامة محتجزة بداخله.",
        beforeImageAlt1: "هاتف ذكي متضرر بشدة مع شاشة مكسورة.",
        afterTitle: "بعد: تم استعادة البيانات بنجاح!",
        afterDescription1: "بفضل خبرة ساي تك، تم استرداد جميع البيانات الهامة، مما جلب الراحة والفرح لصاحبه.",
        afterImageAlt1: "هاتف ذكي يعرض رسالة نجاح أو ملفات مستردة.",
        beforeDescription2: "جهاز متضرر من الماء، يرفض التشغيل. جهات اتصال عمل هامة وملفات مشاريع كانت على المحك.",
        beforeImageAlt2: "هاتف ذكي تظهر عليه علامات التلف بسبب الماء.",
        afterDescription2: "عمل ساي تك الدقيق أعاد البيانات، مما ضمن استمرارية العمل.",
        afterImageAlt2: "هاتف ذكي يعرض قائمة بجهات الاتصال أو الملفات المستردة.",
        pricingOfferTitle: "أسعار شفافة",
        pricingOfferText: "استرجع بياناتك الثمينة مقابل 2000 ريال سعودي، بالإضافة إلى تكاليف الشحن (ذهابًا وإيابًا).",
        pricingOfferDetails: "هذا السعر الثابت يغطي معظم حالات استعادة بيانات آيفون الشائعة. الحالات المعقدة قد تتطلب عرض سعر مخصص بعد التقييم الأولي. اتصل بنا لمزيد من التفاصيل.",
        ourProcessTitle: "عملية الاسترداد البسيطة لدينا",
        processStep1Title: "1. إرسال الطلب والدفع",
        processStep1Desc: "املأ نموذجنا الآمن عبر الإنترنت بتفاصيل جهازك وأكمل الدفع المبدئي.",
        processStep2Title: "2. شحن سهل",
        processStep2Desc: "سيتصل بك شريك الشحن لترتيب استلام جهازك بشكل مناسب.",
        processStep3Title: "3. استرداد احترافي",
        processStep3Desc: "سيعمل فنيونا ذوو الخبرة بدقة لاستعادة بياناتك القيمة.",
        processStep4Title: "4. إعادة البيانات",
        processStep4Desc: "بمجرد استردادها، سنعيد بياناتك وجهازك إليك بأمان.",

        // Contact Us Page
        contactUsTitle: "اتصل بنا",
        contactUsSubtitle: "هل لديك أسئلة؟ نود أن نسمع منك.",
        contactFormTitle: "أرسل لنا رسالة",
        nameLabel: "الاسم",
        messageLabel: "الرسالة",
        sendMessageButton: "إرسال الرسالة",
        sendingMessage: "جار الإرسال...",
        messageSentSuccess: "تم إرسال رسالتك بنجاح!",
        messageSentError: "فشل إرسال الرسالة. يرجى المحاولة مرة أخرى.",
        contactInfoTitle: "معلومات الاتصال",
        contactAddress: "7575 طريق الملك عبدالعزيز، غرناطة، سيهات 32434، المملكة العربية السعودية",
        contactPhone: "+966547399661",
        contactWhatsApp: "تواصل معنا عبر الواتساب",
        contactPOBox: "ص.ب: [صندوق البريد الخاص بك هنا]",

        // About Us Page
        aboutTitle: "عن ساي تك",
        aboutSubtitle: "شركاؤك في الإحياء الرقمي. نعيد البيانات المفقودة إلى الحياة.",
        aboutOurStoryTitle: "قصتنا",
        aboutOurStoryP1: "تأسست ساي تك من شغف بالتكنولوجيا ورغبة عميقة في حل المشاكل المعقدة، وبدأت بمهمة بسيطة: استعادة ما كان يُعتقد أنه مفقود. فنينا الرئيسي، بخبرة 14 عامًا في مجال إلكترونيات الطيران عالي الدقة، يجلب مستوى من الدقة والانضباط لاستعادة البيانات لا مثيل له.",
        aboutOurStoryP2: "نحن نؤمن بأن كل بايت من البيانات يروي قصة، أو يحمل ذكرى، أو يدير عملاً. فقدانه يمكن أن يكون مدمراً. لهذا السبب، كرسنا أنفسنا لإتقان فن استعادة البيانات المعقد، والجمع بين التكنولوجيا المتطورة والخبرة العملية الدقيقة لإعادة توحيدك مع حياتك الرقمية.",
        aboutFeature1Title: "هندسة دقيقة",
        aboutFeature1Desc: "بالاعتماد على خلفية في ميكانيكا الطيران، نطبق عمليات دقيقة ومنهجية على كل مهمة استرداد.",
        aboutFeature2Title: "التركيز على العميل",
        aboutFeature2Desc: "نعطي الأولوية للتواصل الواضح والشفافية، ونبقيك على اطلاع في كل خطوة على الطريق.",
        aboutFeature3Title: "تكنولوجيا متطورة",
        aboutFeature3Desc: "نستثمر في أحدث الأدوات والتقنيات للتعامل مع أصعب سيناريوهات استعادة البيانات.",
        aboutJoinUsTitle: "انضم إلى قصة نجاحنا",
        aboutJoinUsDesc: "ثق بنا بجهازك، ودعنا نجعلك قصة نجاحنا التالية. نحن لا نستعيد البيانات فقط؛ نحن نعيد راحة البال.",

        // Shipping Policy
        shippingPolicyTitle: "سياسة التوصيل والشحن",
        shippingPolicyContact: "سيتصل بك شريك الشحن لدينا في غضون 48 ساعة عمل لترتيب استلام جهازك.",
        shippingPolicyCosts: "تكاليف الشحن، سواء لإرسال الجهاز إلينا أو إعادته، هي مسؤولية العميل.",
        shippingPolicyReturn: "بعد نجاح استعادة البيانات، سنقوم بشحن بياناتك المستردة في غضون 48 ساعة عمل.",
        shippingPolicyOwnership: "كجزء من اتفاقية الخدمة، تنتقل ملكية الجهاز الأصلي إلى ساي تك عند اكتمال العملية.",

        // Refund Policy
        refundPolicyTitle: "سياسة استرداد الأموال",
        refundPolicyGeneral: "سيتم إضافة المبالغ المستردة إلى طريقة الدفع الأصلية وستتم معالجتها في غضون 10 إلى 45 يومًا، اعتمادًا على البنك المصدر لبطاقة الائتمان.",
        refundPolicyCancellation: "استرداد كامل المبلغ متاح إذا تم طلب الإلغاء قبل شحن الجهاز إلى متجرنا، أو في غضون 10 أيام من الدفع إذا لم يتم شحن الجهاز بعد.",
        refundPolicyPartial: "في الحالات التي يتعذر فيها استرداد البيانات، سيتم إصدار استرداد جزئي بقيمة 1200 ريال سعودي. يتم الاحتفاظ برسوم قدرها 300 ريال سعودي للتقييم الفني والمعالجة.",
        refundPolicyDamaged: "سيتم إصدار استرداد كامل المبلغ في حالة تلف الجهاز أثناء الشحن.",

        // Privacy Policy
        privacyPolicyTitle: "سياسة الخصوصية",
        privacyPolicyIntro: "خصوصيتك تهمنا بشكل كبير. توضح هذه السياسة كيف نتعامل مع معلوماتك الشخصية وبياناتك ونحميها.",
        privacyPolicyDataHandling: "التعامل مع البيانات: بمجرد استعادة بياناتك، يتم نقلها فورًا إلى قرص صلب آمن ومشفّر. ثم يتم تجهيز هذا القرص الصلب للشحن إليك.",
        privacyPolicyConfidentiality: "السرية: تم تصميم عملية الاسترداد لدينا لتكون غير تدخلية. لا يطلع الفنيون لدينا على محتويات ملفاتك. نحافظ على سرية تامة ولا نصل إلا إلى بنية البيانات اللازمة لإجراء الاسترداد.",
        privacyPolicySecurity: "الأمان: نطبق مجموعة متنوعة من الإجراءات الأمنية للحفاظ على سلامة معلوماتك الشخصية وبياناتك المستردة طوال العملية بأكملها.",
        privacyPolicyNoStore: "لن يتم تخزين أو بيع أو مشاركة أو تأجير أو تأجير أي من تفاصيل بطاقات الائتمان/الخصم والمعلومات الشخصية لأي طرف ثالث.",
        privacyPolicyPaymentProvider: "إذا قمت بالدفع مقابل منتجاتنا أو خدماتنا على موقعنا، فسيتم تقديم التفاصيل التي يُطلب منك إرسالها مباشرةً إلى مزود الدفع الخاص بنا عبر اتصال آمن.",
        privacyPolicyThirdPartyLinks: "نحن لسنا مسؤولين عن سياسات الخصوصية للمواقع التي نرتبط بها. إذا قمت بتقديم أي معلومات إلى هذه الأطراف الثالثة، فقد يتم تطبيق قواعد مختلفة فيما يتعلق بجمع واستخدام معلوماتك الشخصية.",
        privacyPolicyAds: "حاليًا، لا نستخدم شبكات إعلانية تابعة لجهات خارجية. ومع ذلك، في المستقبل، قد يتم تسليم بعض الإعلانات بواسطة جهات خارجية قد تجمع معلومات حول أنشطتك عبر الإنترنت. لا تغطي سياسة الخصوصية هذه ممارسات المعلومات الخاصة بهذه الأطراف الثالثة.",

        // Terms and Conditions
        tncTitle: "الشروط والأحكام",
        tncIntro: "مرحبًا بك في ساي تك. تحدد هذه الشروط والأحكام القواعد واللوائح الخاصة باستخدام موقعنا وخدماتنا.",
        tncGoverningLawTitle: "القانون الحاكم والاختصاص القضائي",
        tncGoverningLawText1: "أي نزاع أو مطالبة تنشأ عن أو فيما يتعلق بهذا الموقع الإلكتروني يجب أن تخضع وتفسر وفقًا لقوانين {country}.",
        tncGoverningLawText2: "{country} هي بلد إقامتنا.",
        tncUserAgeTitle: "عمر المستخدم",
        tncUserAgeText: "لا يجوز للعملاء الذين يستخدمون الموقع وهم قاصرون / تحت سن 18 عامًا التسجيل كمستخدم للموقع ولا يجوز لهم التعامل أو استخدام الموقع.",
        tncPaymentTitle: "الدفع",
        tncPaymentText: "نقبل الدفع عبر الإنترنت باستخدام بطاقات فيزا وماستركارد الائتمانية / الخصم المباشر بعملة {currencies}.",
        tncCardholderResponsibility: "يجب على حامل البطاقة الاحتفاظ بنسخة من سجلات المعاملات وسياسات وقواعد التاجر.",
        tncAccountConfidentiality: "المستخدم مسؤول عن الحفاظ على سرية حسابه.",
        tncPolicyUpdatesTitle: "تحديثات السياسة",
        tncPolicyUpdatesText: "قد يتم تغيير أو تحديث سياسات الموقع والشروط والأحكام من حين لآخر لتلبية المتطلبات والمعايير. لذلك، يتم تشجيع العملاء على زيارة هذه الأقسام بشكل متكرر من أجل الاطلاع على التغييرات على الموقع. ستكون التعديلات سارية المفعول في اليوم الذي يتم نشرها فيه.",
        tncOfacTitle: "الدول الخاضعة لعقوبات مكتب مراقبة الأصول الأجنبية",
        tncOfacText: "لن يتعامل {websiteUrl} أو يقدم أي خدمات أو منتجات إلى أي من البلدان الخاضعة لعقوبات مكتب مراقبة الأصول الأجنبية (OFAC) وفقًا لقانون {country}.",
        tncMultipleTransactions: "قد تؤدي المعاملات المتعددة إلى عمليات قيد متعددة في كشف الحساب الشهري لحامل البطاقة.",
        countryName: "المملكة العربية السعودية",


        // Request Form Page
        requestServiceTitle: "طلب خدمة استعادة البيانات",
        requestServiceSubtitle: "املأ النموذج أدناه. سنتواصل معك عبر الواتساب لترتيب شحن الجهاز.",
        yourInformationTitle: "معلوماتك",
        yourInformationDescription: "يرجى تقديم تفاصيل الاتصال والجهاز الخاصة بك.",
        fullNameLabel: "الاسم الكامل",
        fullNamePlaceholder: "اسمك الكامل",
        countryCodeLabel: "رمز الدولة",
        countryCodePlaceholder: "اختر الرمز",
        localPhoneNumberLabel: "رقم الهاتف (واتساب)",
        localPhoneNumberPlaceholder: "5XXXXXXXX",
        emailLabel: "البريد الإلكتروني",
        emailPlaceholder: "youremail@example.com",
        cityLabel: "المدينة",
        cityPlaceholder: "مثال: الدمام",
        regionLabel: "المنطقة/المحافظة",
        regionPlaceholder: "مثال: المنطقة الشرقية",
        phoneModelLabel: "طراز الهاتف",
        phoneModelSelectPlaceholder: "اختر طراز الهاتف",
        previouslyRepairedLabel: "هل تم إصلاح الجهاز من قبل؟",
        previouslyRepairedPlaceholder: "اختر إجابة",
        yesOption: "نعم",
        noOption: "لا",
        deviceConditionLabel: "حالة الجهاز الحالية",
        deviceConditionPlaceholder: "اختر الحالة",
        conditionFellInWater: "سقط في الماء",
        conditionPhysicalDamage: "ضرر مادي (صدمة/سقوط)",
        conditionNoPower: "لا يعمل / لا يوجد طاقة",
        conditionScreenIssue: "مشكلة في الشاشة (بدون ضرر مادي)",
        conditionBatteryIssue: "مشكلة في البطارية",
        conditionSoftwareIssue: "مشكلة برمجية / عالق على الشعار",
        conditionOther: "أخرى",
        issueDescriptionLabel: "وصف المشكلة",
        issueDescriptionPlaceholder: "صف المشكلة في جهاز آيفون الخاص بك بالتفصيل",
        deviceImageLabel: "تحميل صورة للجهاز",
        deviceImagePlaceholder: "اختر ملف...",
        fileNameLabel: "الملف المحدد:",
        paymentMethodLabel: "طريقة الدفع المفضلة",
        paymentMethodPlaceholder: "اختر طريقة الدفع",
        paymentCreditCard: "بطاقة ائتمان (عبر مدى/ميسر)",
        paymentApplePay: "آبل باي (عبر مدى/ميسر - محاكاة)",
        paymentBankTransfer: "تحويل بنكي (STC Pay / مدى - محاكاة)",
        paymentMada: "مدى (عبر ميسر - محاكاة)",
        paymentSTCPay: "STC Pay (عبر ميسر - محاكاة)",
        agreementCheckboxLabel: "لقد قرأت ووافقت على الشروط والأحكام.",
        viewAgreementLink: "عرض الاتفاقية",
        errorAgreementRequiredTitle: "الموافقة مطلوبة",
        errorAgreementRequiredText: "يجب عليك الموافقة على الشروط والأحكام للمتابعة.",
        agreementModalTitle: "الشروط والأحكام",
        agreementTextLine1: "مرحبًا بك في ساي تك! تحدد هذه الشروط والأحكام القواعد واللوائح الخاصة باستخدام خدمات استعادة البيانات الخاصة بـ ساي تك.",
        agreementTextLine2: "من خلال الوصول إلى هذا الموقع و/أو إرسال طلب خدمة، نفترض أنك تقبل هذه الشروط والأحكام. لا تستمر في استخدام خدمات ساي تك إذا كنت لا توافق على جميع الشروط والأحكام المذكورة في هذه الصفحة.",
        agreementServiceTitle: "تقديم الخدمة",
        agreementServiceText1: "توافق ساي تك على أداء خدمات استعادة البيانات على الجهاز (الأجهزة) المقدمة من قبلك. سنبذل قصارى جهدنا لاستعادة بياناتك. ومع ذلك، فإن استعادة البيانات ليست مضمونة وتعتمد على حالة الجهاز والبيانات.",
        agreementServiceText2: "يجب دفع رسوم تقييم أولية غير قابلة للاسترداد (إذا كانت مطبقة وتم إبلاغها) ورسوم الخدمة المتفق عليها. تكاليف الشحن لإرسال الجهاز إلينا وإعادته إليك هي مسؤوليتك.",
        agreementPaymentTitle: "الدفع",
        agreementPaymentText1: "تستحق رسوم الخدمة كاملة عند نجاح استعادة البيانات، قبل إعادة بياناتك وجهازك. إذا لم تنجح عملية استعادة البيانات، فسيتم فرض رسوم التقييم فقط (إن وجدت) وتكاليف إعادة الشحن.",
        agreementUserResponsibilityTitle: "مسؤولياتك",
        agreementUserResponsibilityText1: "أنت تؤكد أنك المالك القانوني للجهاز والبيانات الموجودة فيه، أو أنك حصلت على موافقة صريحة من المالك القانوني لتقديم الجهاز لاستعادة البيانات.",
        agreementUserResponsibilityText2: "أنت مسؤول عن وصف حالة الجهاز والمشكلة بدقة. قد يؤثر التحريف على عملية الاسترداد والتكاليف.",
        agreementLimitationTitle: "تحديد المسؤولية",
        agreementLimitationText1: "ساي تك ليست مسؤولة عن أي ضرر يلحق بالجهاز قد يحدث أثناء عملية التقييم أو الاسترداد، خاصة إذا تم العبث بالجهاز مسبقًا أو تعرض لأضرار جسيمة. نحن لسنا مسؤولين عن أي خسارة في الأرباح أو البيانات أو أي أضرار غير مباشرة أو خاصة أو عرضية أو تبعية.",
        agreementConfidentialityTitle: "السرية",
        agreementConfidentialityText1: "سنتعامل مع بياناتك بمنتهى السرية ولن نكشف عنها لأطراف ثالثة، إلا وفقًا لما يقتضيه القانون.",
        agreementShippingTitle: "الشحن وإرجاع الجهاز",
        agreementShippingText1: "أنت مسؤول عن جميع تكاليف الشحن. الأجهزة التي لم تتم المطالبة بها أو التي لم يتم دفع رسوم شحن إعادتها في غضون 60 يومًا من الإخطار قد يتم التخلص منها.",
        agreementChangesTitle: "التغييرات على الشروط",
        agreementChangesText1: "تحتفظ ساي تك بالحق في مراجعة هذه الشروط في أي وقت. باستخدام هذه الخدمة، من المتوقع أن تراجع هذه الشروط بشكل منتظم.",
        agreementContactTitle: "اتصل بنا",
        agreementContactText1: "إذا كان لديك أي أسئلة حول هذه الشروط، يرجى الاتصال بنا.",
        iAgreeButton: "أوافق",
        proceedToPaymentButton: "المتابعة إلى الدفع",
        submittingButton: "جاري الإرسال...",
        errorMissingInfoTitle: "معلومات ناقصة",
        errorMissingInfoText: "يرجى ملء جميع الحقول المطلوبة.",
        errorInvalidEmailTitle: "بريد إلكتروني غير صالح",
        errorInvalidEmailText: "يرجى إدخال عنوان بريد إلكتروني صالح.",
        errorInvalidPhoneTitle: "رقم هاتف غير صالح",
        errorInvalidPhoneText: "يرجى إدخال رمز دولة ورقم هاتف محلي صالح.",
        submissionFailedTitle: "فشل الإرسال",
        submissionFailedText: "حدث خطأ غير متوقع. يرجى المحاولة مرة أخرى.",
        requestSubmittedTitle: "تم إرسال الطلب!",
        requestSubmittedText: "تمت معالجة طلب الخدمة والدفع بنجاح.",
        importantSaveInfoTitle: "هام: احفظ هذه المعلومات!",
        importantSaveInfoText: "يرجى حفظ معرف الطلب ورمز التحقق الخاص بك. ستحتاج إليهما للتحقق من حالة طلبك.",
        requestIdLabel: "معرف الطلب:",
        verificationCodeLabel: "رمز التحقق:",
        transactionIdLabel: "معرف المعاملة:",
        contactWhatsAppText: "سنتواصل معك عبر الواتساب على الرقم {phoneNumber} لترتيب شحن الجهاز.",
        checkStatusNowButton: "تحقق من الحالة الآن",
        paymentModalTitle: "دفع آمن (محاكاة)",
        paymentAmountLabel: "المبلغ للدفع:",
        SAR: "ريال سعودي",
        cardNumberLabel: "رقم البطاقة",
        cardNumberPlaceholder: "•••• •••• •••• ••••",
        expiryDateLabel: "تاريخ انتهاء الصلاحية",
        expiryDatePlaceholder: "MM/YY",
        cvvLabel: "CVV",
        cvvPlaceholder: "•••",
        payNowButton: "ادفع الآن (محاكاة)",
        proceedToSecurePaymentButton: "المتابعة للدفع الآمن (محاكاة)",
        moyasarRedirectMessage: "سيتم توجيهك إلى صفحة ميسر الآمنة لإكمال الدفع بواسطة {paymentMethod}.",
        processingPaymentButton: "جاري معالجة الدفع...",
        paymentSuccessfulTitle: "تم الدفع بنجاح",
        paymentSuccessfulText: "تمت معالجة دفعتك بنجاح.",
        paymentFailedTitle: "فشل الدفع",
        paymentFailedText: "تعذرت معالجة الدفع. يرجى التحقق من التفاصيل أو تجربة بطاقة أخرى.",
        paymentFailedCardDeclined: "تم رفض بطاقتك. يرجى تجربة بطاقة مختلفة أو الاتصال بالبنك الخاص بك.",
        closeButton: "إغلاق",

        // Status Check Page
        checkRequestStatusTitle: "التحقق من حالة الطلب",
        checkRequestStatusSubtitle: "أدخل معرف طلبك لعرض الحالة الحالية لاستعادة بياناتك.",
        orderIdLabel: "معرف الطلب",
        orderIdPlaceholder: "أدخل معرف المعاملة/الطلب",
        errorOrderIdRequired: "يرجى إدخال معرف الطلب",
        useRequestIdButton: "استخدام معرف الطلب",
        usePhoneNumberButton: "استخدام رقم الهاتف",
        requestIdInputLabel: "معرف الطلب",
        requestIdInputPlaceholder: "REQ-XXXXXX",
        phoneNumberInputLabel: "رقم الهاتف",
        phoneNumberInputPlaceholder: "XXXXXXXXX966+",
        sendVerificationCodeButton: "إرسال رمز التحقق",
        sendingCodeButton: "جاري إرسال الرمز...",
        verificationCodeSentTitle: "تم إرسال رمز التحقق",
        verificationCodeSentTextRequestId: "تم إرسال رمز تحقق (وهمي) لمعرف الطلب: {requestId}. يرجى التحقق من قناتك المسجلة.",
        verificationCodeSentTextPhone: "تم إرسال رمز تحقق (وهمي) إلى {phoneNumber}. يرجى التحقق من رسائلك النصية.",
        verificationCodeInputLabel: "رمز التحقق",
        verificationCodeInputPlaceholder: "أدخل الرمز المكون من 6 أرقام",
        checkStatusButton: "تحقق من الحالة",
        checkingStatusButton: "جاري التحقق...",
        changeRequestIdLink: "تغيير معرف الطلب؟",
        changePhoneNumberLink: "تغيير رقم الهاتف؟",
        orResendCodeLink: "أو إعادة إرسال الرمز",
        errorInputRequiredTitle: "الإدخال مطلوب",
        errorEnterRequestId: "يرجى إدخال معرف الطلب الخاص بك.",
        errorEnterPhoneNumber: "يرجى إدخال رقم هاتف صالح (مثال: +966XXXXXXXXX).",
        errorFailedToSendCodeTitle: "فشل إرسال الرمز",
        errorFailedToSendCodeText: "حدث خطأ أثناء إرسال رمز التحقق.",
        errorEnterVerificationCode: "يرجى إدخال رمز التحقق.",
        statusCheckFailedTitle: "فشل التحقق من الحالة",
        statusCheckFailedTextDefault: "تعذر استرداد الحالة.",
        errorNotFoundTitle: "غير موجود",
        errorRequestIdNotFound: "معرف الطلب غير موجود.",
        errorPhoneNumberNotFound: "رقم الهاتف غير موجود أو فشل التحقق.",
        errorGenericTitle: "خطأ",
        statusForRequestId: "حالة الطلب رقم: {requestId}",
        requestStatusTitle: "حالة الطلب",
        multipleRequestsStatusTitle: "حالة طلباتك",
        statusPaid: "مدفوع. في انتظار شحن الجهاز.",
        statusShipped: "تم شحن الجهاز إلى متجرنا.",
        statusDelivered: "تم تسليم الجهاز إلى متجرنا. قيد الفحص.",
        statusEvaluatingDevice: "الجهاز قيد التقييم.",
        statusDataRecovered: "نجحت استعادة البيانات! جاهز للإرجاع.",
        statusDataCantRecover: "للأسف، لم تنجح عملية استعادة البيانات.",
        statusPending: "في انتظار الدفع. يرجى إكمال الدفع للمتابعة.",
        statusErrorInRequest: "خطأ في الطلب.",
        statusUnknown: "حالة غير معروفة",
        paymentCancelledTitle: "تم إلغاء الدفع",
        paymentCancelledText: "تم إلغاء عملية الدفع. يرجى المحاولة مرة أخرى.",
        paymentTimeoutTitle: "انتهت مهلة الدفع",
        paymentTimeoutText: "استغرقت عملية الدفع وقتًا طويلاً. يرجى المحاولة مرة أخرى.",
        paymentInProgressMessage: "الدفع قيد التنفيذ. يرجى إكمال الدفع في النافذة المنبثقة...",
        tryAgainButton: "حاول مرة أخرى",
        popupBlockedTitle: "النافذة المنبثقة محظورة",
        popupBlockedText: "يرجى السماح بالنوافذ المنبثقة لهذا الموقع لإكمال عملية الدفع.",

        // Admin Login Page
        adminLoginTitle: "دخول المسؤول",
        usernameLabel: "اسم المستخدم",
        usernamePlaceholder: "admin",
        passwordLabel: "كلمة المرور",
        passwordPlaceholder: "admin123",
        loginButton: "تسجيل الدخول",
        loggingInButton: "جاري تسجيل الدخول...",
        loginFailedText: "فشل تسجيل الدخول.",

        // Admin Dashboard Page
        adminDashboardTitle: "لوحة تحكم المسؤول",
        refreshRequestsButton: "تحديث الطلبات",
        loadingAdminDashboard: "جاري تحميل لوحة التحكم...",
        errorLoadingDashboardTitle: "خطأ في تحميل لوحة التحكم",
        failedToFetchRequests: "فشل في جلب الطلبات.",
        tableHeaderRequestId: "معرف الطلب",
        tableHeaderCustomer: "العميل",
        tableHeaderPhoneModel: "طراز الهاتف",
        tableHeaderStatus: "الحالة",
        tableHeaderActions: "الإجراءات",
        viewEditButton: "عرض/تعديل",
        requestDetailsTitle: "تفاصيل الطلب: {requestId}",
        customerLabel: "العميل:",
        emailLabelModal: "البريد الإلكتروني:",
        phoneModelLabelModal: "طراز الهاتف:",
        issueLabelModal: "المشكلة:",
        paymentInfoLabelModal: "معلومات الدفع:",
        currentStatusLabelModal: "الحالة الحالية:",
        updateStatusLabelModal: "تحديث الحالة:",
        selectNewStatusPlaceholder: "اختر الحالة الجديدة",
        saveStatusChangeButton: "حفظ تغيير الحالة",
        updatingButtonModal: "جاري التحديث...",
        statusUpdateSuccessText: "تم تحديث حالة الطلب {requestId} إلى {newStatus}",
        statusUpdateFailedText: "فشل تحديث الحالة.",
        statusUpdateErrorText: "خطأ في تحديث الحالة.",
        statusOptionPending: "قيد الانتظار",
        statusOptionPaid: "مدفوع",
        statusOptionShipped: "تم الشحن",
        statusOptionDelivered: "تم التسليم",
        statusOptionEvaluatingDevice: "جاري تقييم الجهاز",
        statusOptionDataRecovered: "تم استرداد البيانات",
        statusOptionDataCantRecover: "لا يمكن استرداد البيانات",
        page: "صفحة",
        of: "من",
        loadingRequests: "جاري تحميل الطلبات...",
        noRequestsFound: "لم يتم العثور على طلبات.",
        searchPlaceholder: "ابحث بالمعرف، الاسم، البريد، الهاتف، الحالة...",
        searchButton: "بحث",
        clearSearchButton: "مسح",
        filterAll: "الكل",
        filterInProgress: "قيد التنفيذ",
        filterDone: "مكتمل",
        filterByStatus: "تصفية حسب الحالة:",

        // Footer
        footerRightsReserved: "© {year} ساي تك. جميع الحقوق محفوظة.",
        footerServiceLocation: "خدمات استعادة البيانات، سيهات، المملكة العربية السعودية.",
        footerContactUs: "اتصل بنا",
        footerEmail: "البريد الإلكتروني:",
        footerPhone: "الهاتف:",
        footerFollowUs: "تابعنا",

        // General
        loadingMessage: "جاري التحميل...",
        requiredFieldIndicator: "*",
    }
};